import Navbar from "../../common/components/HomeNavbar";
import SettingsContent from "./components/SettingsContent";

import { withAuthorization } from "../../common/auth/session";
import { compose } from "recompose";
import useRefreshProfile from "../../common/Hooks/useRefreshProfile";

const Generator = () => {
  useRefreshProfile();

  return (
    <>
      <Navbar title="Account Settings" />
      <div
        style={{
          backgroundColor: "#141414",
          display: "flex",
          flexDirection: "row",
          width: "100%",
        }}
      >
        <SettingsContent />
      </div>
    </>
  );
};

const condition = (authUser) => !!authUser;

export default compose(withAuthorization(condition))(Generator);
